import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconMessageCircle = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.384 4.986c-1.969-.08-3.89.48-5.406 1.556-1.514 1.074-2.51 2.58-2.842 4.219-.33 1.636.014 3.332.992 4.779a1 1 0 0 1 .12.876l-.747 2.242 2.99-.636a1 1 0 0 1 .646.079c1.714.832 3.72 1.086 5.64.706s3.594-1.363 4.725-2.736c1.129-1.369 1.645-3.034 1.483-4.689s-.997-3.228-2.389-4.415c-1.393-1.188-3.244-1.9-5.212-1.98M5.82 4.911c1.893-1.343 4.254-2.02 6.644-1.923s4.675.962 6.43 2.458c1.756 1.498 2.864 3.534 3.08 5.742s-.48 4.396-1.93 6.155c-1.446 1.755-3.54 2.962-5.879 3.425-2.221.44-4.545.187-6.584-.72l-4.374.93a1 1 0 0 1-1.157-1.294l1.15-3.45c-1.063-1.784-1.433-3.853-1.025-5.87.44-2.177 1.75-4.109 3.645-5.453M8 11a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1"
            clipRule="evenodd"
        />
    </svg>
);
